/**
 * Canonical Firestore field names for `resources` documents (camelCase only).
 */
export const RESOURCE_OWNER = {
  instructorId: "instructorId",
  sellerId: "sellerId",
} as const;

export type ResourceOwnerFields = {
  instructorId?: string;
  sellerId?: string;
};

export function normalizeResourceOwnerFields(
  data: Record<string, unknown> | undefined | null
): ResourceOwnerFields {
  if (!data) return {};
  const instructorId = data.instructorId as string | undefined;
  const sellerId = data.sellerId as string | undefined;
  return {
    ...(instructorId !== undefined ? { instructorId } : {}),
    ...(sellerId !== undefined ? { sellerId } : {}),
  };
}

/** Resolve listing/seller user id from a resource-shaped object. */
export function getResourceOwnerUserId(
  resource: Record<string, unknown> | null | undefined
): string | undefined {
  if (!resource) return undefined;
  const { instructorId, sellerId } = normalizeResourceOwnerFields(resource);
  return (
    instructorId ??
    sellerId ??
    (resource.createdBy as string | undefined) ??
    (resource.seller as { id?: string } | undefined)?.id
  );
}
